import {Badge, Group, Modal, Stack, Table, Text} from "@mantine/core";
import {Fragment} from "react";
import {GanttRow} from "./ProductionModuleTimeline.types.ts";

interface ProductionModuleTimelineMaterialsModalProps {
    row: GanttRow | null;
    onClose: () => void;
}

function ProductionModuleTimelineMaterialsModal({
    row,
    onClose,
}: ProductionModuleTimelineMaterialsModalProps) {
    return (
        <Modal
            opened={!!row}
            onClose={onClose}
            title={row ? `Missing Materials for ${row.name}` : "Missing Materials"}
            size="lg"
        >
            <Stack gap="md">
                {row?.materialsStatus.details.map((detail) => (
                    <Fragment key={detail.key}>
                        <Stack gap="xs">
                            <Group justify="space-between" align="start">
                                <Text fw={700}>{detail.title} · {detail.itemLabel}</Text>
                                <Badge size="sm" color="red" variant="light">
                                    Required by {detail.requiredByLabel}
                                </Badge>
                            </Group>
                            <Table striped withTableBorder withColumnBorders>
                                <Table.Thead>
                                    <Table.Tr>
                                        <Table.Th>Material</Table.Th>
                                        <Table.Th>Available</Table.Th>
                                        <Table.Th>Required</Table.Th>
                                        <Table.Th>Missing</Table.Th>
                                    </Table.Tr>
                                </Table.Thead>
                                <Table.Tbody>
                                    {detail.materials
                                        .slice()
                                        .sort((a, b) => b.missing - a.missing)
                                        .map((material) => (
                                            <Table.Tr key={`${detail.key}:${material.name}`}>
                                                <Table.Td>{material.name}</Table.Td>
                                                <Table.Td>{Math.ceil(material.available)}</Table.Td>
                                                <Table.Td>{Math.ceil(material.required)}</Table.Td>
                                                <Table.Td>{Math.ceil(material.missing)}</Table.Td>
                                            </Table.Tr>
                                        ))}
                                </Table.Tbody>
                            </Table>
                        </Stack>
                    </Fragment>
                ))}
                {row && row.materialsStatus.details.length === 0 ? (
                    <Text size="sm" c="dimmed">No missing material details are available for this row.</Text>
                ) : null}
            </Stack>
        </Modal>
    );
}

export default ProductionModuleTimelineMaterialsModal;
